<template>
  <section id="partners">
    <v-container>
      <div class="chapter-eyebrow">
        <span class="ch-label">{{ $t('homepage.partners.label') }}</span>
        <span class="ch-meta">{{ $t('homepage.partners.meta') }}</span>
      </div>

      <div class="partners-list">
        <div
          v-for="(group, index) in partners"
          :key="index"
          class="partners-group"
          :class="[
            group.theme === 'dark' ? 'is-dark' : '',
            !group.name ? 'is-unnamed' : ''
          ]"
        >
          <span v-if="group.name" class="group-label">
            <span class="group-num">0{{ index + 1 }}</span>
            <span class="group-name">{{ $t(group.name) }}</span>
          </span>

          <div class="logos-grid">
            <a
              v-for="(partner, pIndex) in group.items"
              :key="pIndex"
              :href="partner.link"
              target="_blank"
              rel="noopener noreferrer"
              class="partner-logotype"
            >
              <img
                :src="partner.picture"
                alt=""
                :style="`height: ${group.size}px;`"
                class="logo"
                loading="lazy"
                decoding="async"
              />
            </a>
          </div>
        </div>
      </div>
    </v-container>
  </section>
</template>

<script>
export default {
  name: "PartnersComponent",
  data() {
    return {
      partners: [
        {
          name: "homepage.partners.strategic",
          name_size_tag: 'h1',
          size: 64,
          theme: 'dark',
          items: [
            {
              picture: require('@/assets/img/components/partners/logo/Mat.webp'),
              link: 'https://www.mat.net.pl/'
            },
            {
              picture: require('@/assets/img/components/partners/logo/msc.webp'),
              link: 'https://www.msc.com/'
            },
            {
              picture: require('@/assets/img/components/partners/logo/seco.webp'),
              link: 'https://www.secotools.com/'
            },
          ]
        },
        {
          name: "homepage.partners.standard",
          name_size_tag: 'h2',
          size: 60,
          items: [
            {
              picture: require('@/assets/img/components/partners/logo/mnisw.webp'),
              link: 'https://www.gov.pl/web/edukacja'
            },
            {
              picture: require('@/assets/img/components/partners/logo/Atman_białe.webp'),
              link: 'https://www.atman.pl/'
            },
            {
              picture: require('@/assets/img/components/partners/logo/altium.webp'),
              link: 'https://www.altium.com/'
            },
            {
              picture: require('@/assets/img/components/partners/logo/tmeeu_white.webp'),
              link: 'https://www.tme.eu/pl/'
            },
            {
              picture: require('@/assets/img/components/partners/logo/bmchemie.webp'),
              link: 'https://bm-chemie.com/'
            },
            {
              picture: require('@/assets/img/components/partners/logo/m.webp'),
              link: 'https://im-narzedzia.pl/pl/'
            },
            {
              picture: require('@/assets/img/components/partners/logo/indasa.webp'),
              link: 'https://www.indasa-abrasives.com/'
            },
            {
              picture: require('@/assets/img/components/partners/logo/noctua.webp'),
              link: 'https://noctua.at/'
            },
            {
              picture: require('@/assets/img/components/partners/logo/helukabel.webp'),
              link: 'https://helukabel.pl/'
            },
            {
              picture: require('@/assets/img/components/partners/logo/treko.webp'),
              link: 'https://treko-laser.pl/'
            },
            {
              picture: require('@/assets/img/components/partners/logo/airtech.webp'),
              link: 'https://www.airtech.lu/'
            },
            {
              picture: require('@/assets/img/components/partners/logo/mesco.webp'),
              link: 'https://mesco.com.pl/'
            },
            {
              picture: require('@/assets/img/components/partners/logo/3dconexion.webp'),
              link: 'https://3dconnexion.com/'
            },
            {
              picture: require('@/assets/img/components/partners/logo/weip.webp'),
              link: 'https://weip.agh.edu.pl/'
            },
          ]
        },
        {
          name: 'homepage.partners.media',
          name_size_tag: 'h3',
          size: 50,
          items: [
            {
              picture: require('@/assets/img/components/partners/logo/ksaf.webp'),
              link: 'https://www.ksaf.pl/'
            },
            {
              picture: require('@/assets/img/components/partners/logo/mine.webp'),
              link: 'https://www.mine.agh.edu.pl/'
            }
          ]
        }
      ]
    }
  }
}
</script>

<style lang="sass" scoped>
  #partners
    background: #0a0828
    color: #fff
    padding: 130px 0
    position: relative

  .chapter-eyebrow
    display: flex
    align-items: baseline
    gap: 32px
    margin-bottom: 50px

    .ch-label
      font-family: Inter, sans-serif
      font-weight: 700
      font-size: 0.78em
      letter-spacing: 0.22em
      text-transform: uppercase
      color: #fff

    .ch-meta
      font-family: Inter, sans-serif
      font-weight: 500
      font-size: 0.78em
      letter-spacing: 0.16em
      text-transform: uppercase
      color: rgba(255, 255, 255, 0.55)
      margin-left: auto

  .partners-list
    margin-top: 90px

    display: flex
    flex-direction: column
    gap: 80px

  .partners-group
    display: grid
    grid-template-columns: 280px 1fr
    gap: 60px
    align-items: start
    padding-bottom: 80px
    border-bottom: 1px solid rgba(255, 255, 255, 0.12)

    &:last-child
      border-bottom: none
      padding-bottom: 0

  .group-label
    display: flex
    flex-direction: column
    gap: 12px
    position: sticky
    top: 110px

    .group-num
      font-family: Inter, sans-serif
      font-weight: 700
      font-size: 0.78em
      letter-spacing: 0.22em
      text-transform: uppercase
      color: rgba(255, 255, 255, 0.5)

    .group-name
      font-family: Raleway, sans-serif
      font-weight: 900
      font-size: 1.8em
      line-height: 1
      letter-spacing: -0.025em
      text-transform: uppercase
      color: #fff

  .logos-grid
    display: flex
    flex-wrap: wrap
    align-items: center
    gap: 50px 70px

  .partner-logotype
    display: inline-flex
    align-items: center
    text-decoration: none
    transition: all 0.3s ease

    .logo
      opacity: 0.85
      transition: all 0.3s ease
      max-width: 100%

    &:hover .logo
      opacity: 1
      transform: translateY(-2px)

  .partners-group.is-dark
    .logos-grid
      gap: 56px 80px

      .logo
        opacity: 0.95

      .partner-logotype:hover .logo
        opacity: 1

  .partners-group.is-unnamed
    grid-template-columns: 1fr
    gap: 0

    .logos-grid
      gap: 36px 56px
      justify-content: flex-start

      .logo
        opacity: 0.7

      .partner-logotype:hover .logo
        opacity: 1


  @media only screen and (max-width: 1180px)
    h2
      font-size: 4em

  @media only screen and (max-width: 974px)
    #partners
      padding: 90px 0

    .chapter-eyebrow
      gap: 14px
      flex-wrap: wrap

      .ch-meta
        margin-left: 0
        width: 100%

    h2
      font-size: 2.8em
      margin-bottom: 70px

    .partners-list
      gap: 56px

    .partners-group
      grid-template-columns: 1fr
      gap: 28px
      padding-bottom: 56px

    .group-label
      position: static
      flex-direction: row
      align-items: baseline
      gap: 16px

      .group-name
        font-size: 1.4em

    .logos-grid
      gap: 32px 40px

  @media only screen and (max-width: 599px)
    #partners
      padding: 70px 0

    h2
      font-size: 2.2em

    .logos-grid
      gap: 24px 32px
      justify-content: flex-start

      img
        max-height: 36px !important
</style>
